/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import { RESTService, ReduxUtils } from '@spm/core';
import models from './models';

/**
 * Post request to path:
 * /v1/acesdbs/files
 *
 * @param {any} data
 * @param {any} callback function to call once this function has finished
 */
const postAcesdbsFilesUtil = (data = {}, callback) => {
  const url = `${process.env.REACT_APP_REST_URL}/v1/acesdbs/files`;

  RESTService.post(url, data, (success, response) => {
    if (success) {
      const model = new models.NewSPMFileIDResponse(response);
      callback(success, model);
    } else {
      callback(success, response);
    }
  });
};

/**
 * Gets SPMFileDownloadContents from api:
 * /v1/acesdbs/files/{fileId}
 *
 * @param {string} fileId.
 * @param {any} callback function to call once this function has finished
 */
const getAcesdbsFilesByFileIdUtil = (fileId, callback) => {
  ReduxUtils.getModelDataFromRestAPI(
    callback,
    `v1/acesdbs/files/${fileId}`,
    models.SPMFileDownloadContents
  );
};

/**
 * Deletes from api:
 * /v1/acesdbs/files/{fileId}
 *
 * @param {string} fileId.
 * @param {any} callback function to call once this function has finished
 */
const deleteAcesdbsFilesByFileIdUtil = (fileId, callback) => {
  const url = `${process.env.REACT_APP_REST_URL}/v1/acesdbs/files/${fileId}`;
  RESTService.del(url, (success, response) => {
    callback(success, response);
  });
};

export { postAcesdbsFilesUtil, getAcesdbsFilesByFileIdUtil, deleteAcesdbsFilesByFileIdUtil };
